import { CommentShapeTool } from "../../routes/tickets/components/CommentTool/CommentTool";
import { ComboTool } from "../../routes/tickets/components/DefaultTool";
import { LinkShapeTool } from "../../routes/tickets/components/LinkShape";

export const customTools = [CommentShapeTool, LinkShapeTool, ComboTool];
